const fr_translations = {
    map: 'Carte',
    deposit: 'Dépôt',
    no_results : 'Aucun résultat',
    search_address: 'Rechercher une adresse',
    search_pointcash: 'Rechercher un relais Point Cash Services',
    day: "Jour",
    monday: "Lundi",
    tuesday: "Mardi",
    wednesday: "Mercredi",
    thursday: "Jeudi",
    friday: "Vendredi",
    saturday: "Samedi",
    sunday: "Dimanche",
    schedules: "Horaires",
    schedules_information_only: "Horaires donnés à titre indicatif",
    best_navigation: "Cliquez ci-dessous pour obtenir l'itinéraire le plus rapide pour vous rendre au point de vente sélectionné.",
    route: 'Itinéraire',
    map_loading: 'Chargement des points de vente ...',
    no_geoloc: 'Afin de trouver les points de vente les plus proches de votre position, veuillez entrer une adresse dans la barre d\'adresse ci-dessus.',
    remove_route: 'Supprimer l\'itinéraire',
    maintenance: 'Maintenance',
    site_unavailable: 'Site indisponible',
    site_unavailable_text: 'Le site est temporairement inaccessible en raison d’activités de maintenance. Vous pouvez essayer de vous connecter à nouveau dans quelques minutes.',
    thanks_understanding: 'Merci de votre compréhension.',
    page_not_found: 'Page introuvable',
    page_not_found_text: 'Nous sommes désolé mais la page que vous avez demandée n\'existe pas. Si vous pensez qu\'il s\'agit d\'une erreur, veuillez contacter votre administrateur.',
    no_opening_hours: 'Horaires d\'ouverture non disponibles',
    error_occured_while_loading_app : "Une erreur est survenue lors du chargement de l'application.",
    error_occured_while_loading_pos : "Une erreur est survenue lors du chargement des points de vente.",
}

export default fr_translations;
